import React, { createContext, useContext } from 'react';

interface FloatingPortalContextType {
  getPortalElement: () => HTMLElement | null;
}

const FloatingPortalContext = createContext<
  FloatingPortalContextType | undefined
>(undefined);

export interface FloatingPortalProviderProps {
  children: React.ReactNode;
  getPortalElement: () => HTMLElement | null;
}

export const FloatingPortalProvider = ({
  children,
  getPortalElement,
}: FloatingPortalProviderProps) => {
  return (
    <FloatingPortalContext.Provider value={{ getPortalElement }}>
      {children}
    </FloatingPortalContext.Provider>
  );
};

export const useFloatingPortal = (): (() => HTMLElement | null) | null => {
  const context = useContext(FloatingPortalContext);

  if (context === undefined) {
    return null;
  }

  return context.getPortalElement;
};
